import React from "react";
import img1 from "../images/coach.png";
import img2 from "../images/support.png";
import img3 from "../images/mindset.png";
import img4 from "../images/innovation.png";

const Why = () => {
  const features = [
    {
      id: 1,
      icon: img1,
      text: "Personalized coaching tailored to your journey",
    },
    {
      id: 2,
      icon: img2,
      text: "Safe, supportive and non-judgmental space",
    },
    {
      id: 3,
      icon: img3,
      text: "Focus on mindset and action",
    },
    {
      id: 4,
      icon: img4,
      text: "Sustainable transformation—not quick fixes",
    },
  ];
  return (
    <>
      <section className="animate">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>WHY ANCHOR POINT</h2>
            </div>
            {features.map((feature) => (
              <div key={feature.id} className="col-lg-3 col-md-6 mb-5">
                <div className="mission_card">
                  <div className="mission_card_icon">
                    <img src={feature.icon} alt="" />
                  </div>
                  <p>{feature.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Why;
